declare const window:any;
export const downloadFunc:Function = function(options:any){
    let defaults:any = {
        method: "GET",
        url: "",
        fileName: "",
        param: [],
        fileType: "", //文件类型 例如'application/pdf'
    };
    for(let defaultI in defaults){
        if(typeof(options[defaultI])=='undefined'){
            options[defaultI] = defaults[defaultI];
        }
    }
    let downloadUrl:string = options.url;
    if (typeof (downloadUrl) != 'string') {
        window.nsAlert('下载地址url错误，无法下载', 'error');
        console.error('下载地址url错误，无法下载', options);
    }
    //token可能在下载链接的URL里，如果没有则从本地存储取
    let authorization:any = '';
    if (options.method.toUpperCase() == 'GET') {
        //如果是GET 则author可能在url上
        let urlParams = window.NSUtils.getUrlPara(downloadUrl);
        if (urlParams.Authorization) {
            authorization = urlParams.Authorization;
        }
    }
    if (authorization == '') {
        authorization = window.NSUtils.OAuthCode.get();
        if (authorization == false) {
            window.nsAlert('获取token错误，无法下载', 'error');
            console.error('获取token错误，无法下载', options);
            return false;
        }
    }
    if (options.url && options.param) {
        let xhr:any = new XMLHttpRequest();
        let a:any = document.createElement('a'); // 转换完成，创建一个a标签用于下载
        a.download = options.fileName;
        xhr.open('get', options.url, true);
        xhr.setRequestHeader('Content-Type', 'application/json'); // 设置请求头，必须在open后添加application/x-www-form-urlencoded
        xhr.setRequestHeader('Authorization', authorization);
        xhr.responseType = 'blob'; // 返回类型blob  blob 存储着大量的二进制数据
        xhr.onload = function () {
            if (this.status === 200) {
                let blob = new Blob([this.response], { type: options.fileType }); // 转成文本存储
                // let name = xhr.getResponseHeader('content-disposition');
                // let a = document.createElement('a'); // 转换完成，创建一个a标签用于下载
                a.download = options.fileName;
                a.href = window.URL.createObjectURL(blob); // 转成本地连接到blob文本
                if (document.createEvent) {
                    let evt:any = document.createEvent("MouseEvents");
                    evt.initEvent('click', true, false);
                    a.dispatchEvent(evt);
                } else if(window.document.createEventObject) {
                    a.fireEvent('onclick');
                } else if (typeof a.onclick == 'function') {
                    a.onclick();
                }
            }
        }
        xhr.send(); // 发送ajax请求
    };
}